import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Dialog,
} from "@mui/material";
import PropTypes from "prop-types";
import OptionsSelection from "./OptionsSelection";
import React, { useState, useEffect } from "react";
import { getVariations, getBulkPrices } from "../apis/RangerOnlineApi";
import { DialogHeader } from "./DialogHeader";
import { handleItemSelection } from "../Utils/utils";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    //boxShadow: "3px 3px 3px 3px #972020",
    //boxShadow: `3px 2px "#972020"`,
    border: "solid",
    borderWidth: "3px",
    borderColor: "#972020",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

export const DialogProduct = (props) => {
  const {
    product,
    variations,
    onProductAdd,
    onClose,
    open,
    variationConfig,
    steps,
    onPopUp,
    settings,
  } = props;

  const [productCopy, setProductCopy] = useState(product);
  const [variationsCopy, setVariationsCopy] = useState(variations);
  const [currentVariation, setCurrentVariation] = useState(null);
  const [activeStep, setActiveStep] = React.useState(1);
  const [levelConfig, setLevelConfig] = useState({});
  const [bulkPricing, setBulkPricing] = useState([]);
  const [note, setNote] = useState("");

  const getCurrentLevelConfig = (level, configuration) => {
    if (configuration) {
      const maxQuantity = configuration["qtyLevel" + level];
      const forcedOption = configuration["mandatoryLevel" + level];
      const levelName = configuration["nameLevel" + level];

      return {
        maxQuantity: maxQuantity,
        forcedOption: forcedOption,
        levelName: levelName,
      };
    }
    return {};
  };

  const handleNext = () => {
    const level = activeStep + 1;
    if (activeStep !== steps.length) {
      const currentStep = steps.find((x) => x.level === activeStep);
      if (currentStep.currentLevelConfig.forcedOption === 1) {
        const selectedVariations = variationsCopy.filter(
          (x) => x.level === activeStep && x.enabled
        );
        const selectedVariationsQty = selectedVariations.length;
        if (
          selectedVariationsQty < currentStep.currentLevelConfig.maxQuantity
        ) {
          onPopUp(
            `You must select at least ${currentStep.currentLevelConfig.maxQuantity} options.`,
            false
          );
          return;
        }
        for (let i = 0; i < selectedVariationsQty; i++) {
          const variation = selectedVariations[i];
          const subVariations = variation?.subVariations || [];
          if (subVariations.length > 0) {
            if (
              variation.maxQuantity > 0 &&
              subVariations.filter((x) => x.enabled).length <
                variation.maxQuantity
            ) {
              onPopUp(
                `You must select at least ${variation.maxQuantity}`,
                false
              );
              return;
            }
          }
        }
      }
    }

    const configuration = getCurrentLevelConfig(level, variationConfig);
    setLevelConfig(configuration);
    setActiveStep(level);
  };

  const handleBack = () => {
    const level = activeStep - 1;
    setLevelConfig(getCurrentLevelConfig(level, variationConfig));
    setActiveStep(level);
  };

  const handleVariationClick = async (id) => {
    const variations = [...variationsCopy];
    let currentProduct = { ...productCopy };
    const index = variations.findIndex((x) => x.id === id);
    const variation = variations[index];

    if (
      currentProduct?.selectedVariations?.filter((x) => x.level === activeStep)
        ?.length === levelConfig.maxQuantity &&
      !currentProduct?.selectedVariations.find((x) => x.id === id)
    ) {
      onPopUp("You've chosen the max quantity.", false);
      return;
    }

    variation.enabled = !variation.enabled;

    if (currentProduct?.selectedVariations?.length > 0) {
      if (!variation.enabled) {
        currentProduct.selectedVariations =
          currentProduct.selectedVariations.filter((x) => x.id !== id);
      } else {
        currentProduct.selectedVariations.push(variation);
      }
    } else {
      let selectedVariations = [];
      selectedVariations.push(variation);
      Object.assign(currentProduct, { selectedVariations: selectedVariations });
    }

    if (!variation?.subVariations) {
      let subVariations = await getVariations(
        currentProduct.productId,
        variation.id
      );

      if (subVariations?.status) {
        subVariations = [];
      }

      Object.assign(variation, { subVariations: subVariations });
    }

    if (variation?.subVariations?.length > 0 && !variation.enabled) {
      variation.subVariations.map((x) => (x.enabled = false));
    }
    if (variation?.subVariations?.length == 1 && variation.enabled) {
      variation.subVariations.map((x) => (x.enabled = true));
    }

    setProductCopy(currentProduct);
    setCurrentVariation(id);
    setVariationsCopy(variations);
  };

  const handleSubVariationClick = async (index) => {
    const variations = [...variationsCopy];
    const variation = variations.find((x) => x.id === currentVariation);
    let subVariation = variation.subVariations[index];
    if (subVariation.enabled) {
      subVariation.enabled = !subVariation.enabled;
      if (variation.subVariations.length == 1) {
        variation.enabled = !variation.enabled;
      }
      setVariationsCopy(variations);
      return;
    }
    if (
      variation.subVariations.filter((x) => x.enabled).length >=
        variation.maxQuantity &&
      variation.subVariations.find((x) => x.id === subVariation.id && x.enabled)
    ) {
      onPopUp(`You've chosen the max quantity.`, false);
      return;
    }

    subVariation.enabled = !subVariation.enabled;
    setVariationsCopy(variations);
  };

  const handleQuantityChange = (newQuantity) => {
    const currentProduct = { ...productCopy };
    if (
      currentProduct?.validateMinQtySell &&
      currentProduct?.validateMinQtySell > 0 &&
      newQuantity < currentProduct?.minQtySell
    ) {
      onPopUp(
        `The minimum quantity you have to buy is: ${currentProduct.minQtySell}.`,
        false
      );
      return;
    }

    if (
      currentProduct?.validateMaxQtySell &&
      currentProduct?.validateMaxQtySell > 0 &&
      newQuantity > currentProduct?.maxQtySell
    ) {
      onPopUp(`You can only buy ${currentProduct.maxQtySell}.`, false);
      return;
    }
    currentProduct.quantity = newQuantity;
    setProductCopy(currentProduct);
  };

  const handleNoteChange = (e) => {
    const value = e.target.value;
    setNote(value);
  };

  const handleSave = () => {
    const productItem = handleItemSelection(
      { ...productCopy },
      variations,
      bulkPricing,
      note
    );
    onProductAdd(productItem);
  };

  useEffect(() => {
    if (Object.keys(levelConfig).length === 0) {
      setLevelConfig(getCurrentLevelConfig(activeStep, variationConfig));
    }

    if (bulkPricing.length === 0) {
      getBulkPrices(productCopy.productId).then((x) => setBulkPricing(x));
    }
  }, []);

  return (
    <BootstrapDialog
      keepMounted={false}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="sm"
      fullWidth={true}
    >
      {open ? (
        <>
          <DialogHeader
            title={product.productName}
            subTitle={product.productDescription}
          />
          <DialogContent dividers>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection="column"
            >
              <OptionsSelection
                product={productCopy}
                steps={steps}
                variations={variationsCopy}
                currentLevelConfig={levelConfig}
                currentVariation={currentVariation}
                onBackClick={handleBack}
                onNextClick={handleNext}
                activeStep={activeStep}
                onVariationClick={async (index) =>
                  await handleVariationClick(index)
                }
                onSubVariationClick={async (index) =>
                  await handleSubVariationClick(index)
                }
                onNoteChange={handleNoteChange}
                note={note}
                onCounterClick={(param) => handleQuantityChange(param)}
                onPopUp={onPopUp}
                settings={settings}
              />
            </Box>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              variant="outlined"
              color="primary"
              autoFocus
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              autoFocus
              onClick={handleSave}
              disabled={!(activeStep === steps.length)}
            >
              Add to Order
            </Button>
          </DialogActions>
        </>
      ) : null}
    </BootstrapDialog>
  );
};
